var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliveryMethodIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 39,
    viewBox: "0 0 46 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0527 0H4.10532C1.84743 0 6.10352e-05 1.84737 6.10352e-05 4.10526V20.5263H4.10532V4.10526H41.0527V36.9474C43.3106 36.9474 45.158 35.1 45.158 32.8421V4.10526C45.158 1.84737 43.3106 0 41.0527 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4212 22.5789C20.9557 22.5789 24.6317 18.9029 24.6317 14.3684C24.6317 9.83385 20.9557 6.15787 16.4212 6.15787C11.8866 6.15787 8.21063 9.83385 8.21063 14.3684C8.21063 18.9029 11.8866 22.5789 16.4212 22.5789Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5375 27.8337C26.0891 26.0684 21.6143 24.6316 16.4212 24.6316C11.228 24.6316 6.75329 26.0684 3.30487 27.8337C2.30331 28.3495 1.46428 29.1328 0.880917 30.0967C0.297556 31.0605 -0.00731837 32.1671 0.000133401 33.2937V39H32.8422V33.2937C32.8422 30.9947 31.5901 28.8805 29.5375 27.8337Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryMethodIcon);
export default __webpack_public_path__ + "static/media/DeliveryMethodIcon.3695c46d231cb76aabada84a653d0da7.svg";
export { ForwardRef as ReactComponent };